'use client'
import {UseSessionClient} from "../../../../hooks/useSessionClient";
import ErrorPage from "../../../../partials/error";

export default function Error({error,reset}) {

    return <UseSessionClient><ErrorPage error={error} reset={reset} /></UseSessionClient>
}